var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"position-tips",class:[_vm.direction],style:({ left: _vm.position.left, top: _vm.position.top })},[_c('div',{staticClass:"position-content"},[_c('div',{staticClass:"tips-con"},[_vm._v(_vm._s(_vm.text))]),_c('div',{staticClass:"position-tran"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }